module.exports = __webpack_public_path__ + "es.4398afa5eb37f70f9e2f.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/es.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/es.svg
// module chunks = styles